export enum ManagerQuotaPermissionTypes {
    Disabled = 1,
    QuotasCreditsCreator = 2,
    QuotasRulesCreator = 4,

    // tslint:disable-next-line:no-bitwise
    Full = QuotasCreditsCreator | QuotasRulesCreator,
}
